import IconProps from "./icon-props";

export default function TwitterIcon({ className }: IconProps) {
  return (
    <svg className={className} viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.392857" y="0.392857" width="43.2143" height="43.2143" rx="21.6071" fill="white" />
      <rect x="0.392857" y="0.392857" width="43.2143" height="43.2143" rx="21.6071" stroke="#E1E9ED" strokeWidth="0.785714" />
      <path d="M11.8332 12.5703L19.612 22.9711L11.7842 31.4275H13.546L20.3994 24.0236L25.9366 31.4275H31.9319L23.7152 20.4417L31.0014 12.5703H29.2395L22.9281 19.3889L17.8285 12.5703H11.8332ZM14.4241 13.868H17.1783L29.3406 30.1298H26.5864L14.4241 13.868Z" fill="#131834" />
      <path d="M13.749 13.3564H17.2847L30.249 30.6422H26.3205L13.749 13.3564Z" fill="#131834" />
    </svg>
  )
}